export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_FAMILY_MEMBER":
      return [...state, action.payload.familyMember];
    case "UPDATE_FAMILY_MEMBER":
      console.warn('family', action.payload.familyMember);
      return action.payload.familyMember;
    case "DELETE_FAMILY_MEMBER":
      return state.filter((familyMember) => {
        return familyMember.id !== action.payload.familyMember.id;
      });
    default:
      return state;
  }
};
